<div class="cart-section">
  <h3 class="primary-color no-margin"><b>MA SELECTION</b></h3>
  <div *ngIf="!loading">
    <h2>Passer commande</h2>
    <p *ngIf="reservationList !== undefined && reservationList.length === 0">
      Votre panier est vide, trouver une formation dans notre catalogue
    </p>
    <button (click)="searchFormation()" class="colored-text cart-link-bt k-button-icontext k-button k-primary">
      Rechercher une formation
    </button>
    <ags-one-cart
      *ngFor="let resa of reservationList; let i = index"
      [resa]="resa"
      [userConnected]="userConnected"
      (displayPopup)="displayPopup = true"
      (remove)="removeResa(i)"
    ></ags-one-cart>
  </div>
  <div *ngIf="loading">
    <p>Chargement de votre panier...</p>
  </div>
</div>
<div *ngIf="displayPopup">
  <kendo-window>
    <kendo-window-titlebar class="small-padding">
      <div class="k-window-title">Confirmation</div>
    </kendo-window-titlebar>
    <div class="align-center msg-content">
      <p class="small-margin">La création d'un compte client est nécessaire pour commander en ligne</p>
      <button kendoButton type="button" [primary]="true" (click)="Redirect()">Ok</button>
    </div>
  </kendo-window>
</div>
